module.exports = __webpack_public_path__ + "static/HyperionTopD-c2cb1d7971c86397db6593d0999554b8.png";